var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-content-section flex flex-col items-center justify-center pt-10 pb-6 overflow-hidden px-4"},[_c('section-title',{attrs:{"title-path":"title-1.png"}}),_c('div',{staticClass:"row w-full max-w-1280 flex flex-wrap justify-center mt-14 z-10"},_vm._l((_vm.contents),function(content,index){return _c('a',{key:content.image,staticClass:"menu-btn relative inline-block w-123 h-119 m-1 bg-cover bg-no-repeat cursor-pointer",style:({
        'background-image':
          'url(' +
          _vm.imgPath +
          '/slide2/content' +
          (index + 1) +
          '_sprites.png)',
      }),attrs:{"href":content.link}})}),0),_c('img',{staticClass:"absolute bottom-1/10 right-0.3/10 h-auto m-auto",attrs:{"src":_vm.imgPath + '/slide2/bird.png'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }